function isValidEmail(input: string | null | undefined): boolean {
  const trimmed = input?.trim();

  if (trimmed == null || trimmed.length === 0) {
    return false;
  }

  const parts = trimmed.split('@');

  if (parts.length !== 2) {
    return false;
  }

  if (parts[0].length === 0) {
    return false;
  }

  if (parts[1].length === 0) {
    return false;
  }

  if (!parts[1].includes('.')) {
    return false;
  }

  if (parts[1][parts[1].length - 1] === '.') {
    return false;
  }

  if (parts[1][0] === '.') {
    return false;
  }

  return true;
}

export default isValidEmail;
